import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION9: PdfComponent = {
  type: 'section',
  id: 's9',
  title: '9. Set-Off',
  content: [
    {
      type: 'bulletList',
      id: 's9bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Without affecting its other rights and remedies, Kanda may set off any amount owed to it by the Subscriber against any amount which it owes to the Subscriber, whether present or future and arising under this Agreement',
        },
      ],
      prefix: '9',
    },
  ],
};
